import React from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import TextField from "@mui/material/TextField";
import { Alert } from "@mui/material";
import MUIDataTable from "mui-datatables";
import styled from "styled-components";
import LinearProgress from "@mui/material/LinearProgress";
import { Snackbar } from "@mui/material";
import { useEffect, useState } from "react";
import {
  useLazyGetMinutesQuery,
  useDeleteMinuteMutation,
  useLazyGetClusteringQuery,
  useLazyGetCauseQuery,
} from "../../../services/minute";
import { useLazyGetKeywordsQuery } from "../../../services/keyword";
import "./ListPage.module.scss";
import { Link } from "react-router-dom";
import { Path } from "../../../Routes";
import Stack from "@mui/material/Stack";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import Popover from "@mui/material/Popover";

const Title = styled.p`
  font-size: 20px;
  color: #666666;
  font-weight: bold;
  margin-top: 1px;
  margin-bottom: 2px;
  margin-left: 20px;
  text-align: left;
  width: 200px;
`;

const SearchTypography = styled.p`
  font-size: 18px;
  font-weight: bold;
  color: #666666;
  margin-bottom: 0px;
  margin-top: 0px;
`;

const TextInit = styled.p`
  font-size: 18px;
  // font-weight: bold;
  color: #666666;
  margin-bottom: 5px;
  margin-top: 0px;
`;
const SearchTextInput = styled(TextField)`
  width: 100%;
`;

const ButtonDiv = styled.div`
  margin-top: 55px;
  margin-left: 100px;
`;

const DeleteModalDiv = styled.div`
  margin-top: 50px;
  margin-left: 0px;
`;

const CustomButton = styled(Button)`
  width: 90px;
`;

const DeleteCustomButton = styled(Button)`
  width: 120px;
`;

const SearchDiv = styled.div`
  margin-left: 50px;
  margin-top: 25px;
`;

const TableDiv = styled.div`
  margin-top: 20px;
  margin-right: 2px;
  margin-left: 2px;
`;

const DeleteBoxStyle = {
  position: "absolute" as const,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 10,
  p: 4,
};

type ErrorResponse = {
  detail_msg: string | null;
  code: number | null;
};

const options = {
  // 高さ指定
  tableBodyHeight: "650px",

  // 最終更新日時でソート
  sortOrder: { name: "updated_timestamp" as any, direction: "desc" as any },

  // 列選択のcheckboxを表示しない
  selectableRows: false as any,
  filter: false,
  search: true,
  print: false,
  download: false,
  viewColumns: false,

  rowsPerPage: 100,
  rowsPerPageOptions: [],
  textLabels: {
    body: {
      noMatch: `表示できるデータが存在しません`,
    },
  },
};

const ListPage = (): JSX.Element => {
  const [search, setSearch] = useState("");
  const [
    getMinutes,
    {
      data: getMinutesData,
      error: getMinutesError,
      isFetching: getMinutesFetching,
    },
  ] = useLazyGetMinutesQuery();
  const [
    deleteMinute,
    {
      data: deleteMinuteData,
      error: deleteMinuteError,
      isSuccess: deleteMinuteSuccess,
      reset: deleteMinuteReset,
    },
  ] = useDeleteMinuteMutation();
  const initMsg = `キーワードで検索すると該当する商談メモを表示できます。(入力無しの場合は全件表示)\n新規追加から商談メモを登録できます。`;
  const [open, setOpen] = React.useState(false);
  const handleOpen = (id: string) => {
    setOpen(true);
    setId(id);
  };
  const handleClose = () => setOpen(false);
  const [id, setId] = useState("");
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handlePopoverClose = () => {
    setAnchorEl(null);
  };
  const [disabledDeleteButton, setDisabledDeleteButton] = React.useState(true);
  const popoverOpen = Boolean(anchorEl);

  // バリデーション用のステート
  const [searchError, setSearchError] = useState(false);

  // snackbar表示用
  const [errorOpen, setErrorOpen] = React.useState(false);
  const [infoOpen, setInfoOpen] = React.useState(false);
  const errorHandleClose = () => {
    setErrorOpen(false);
  };
  const infoHandleClose = () => {
    setInfoOpen(false);
  };
  const [errMessage, setErrMessage] = useState<string | null>(null);
  const [infoMessage, setInfoMessage] = useState<string | null>(null);

  // 初回API起動用
  const [getKeywords] = useLazyGetKeywordsQuery();
  const [triggerGetClustering] = useLazyGetClusteringQuery();
  const [triggerGetCause] = useLazyGetCauseQuery();

  useEffect(() => {
    const hasVisited = sessionStorage.getItem("hasVisited");
    if (!hasVisited) {
      // 初回のみ実行
      const formData = {
        word: "test",
        id: "000",
      };
      const keyword = formData.word;
      const fetchKeywords = async () => {
        try {
          await getKeywords(formData);
        } catch (error) {
          console.log("予期せぬエラーが発生しました:", error);
        }
      };
      const fetchClustering = async () => {
        try {
          await triggerGetClustering({
            keyword,
            cluster_filter: 0.9,
            issue_filter: 0.9,
          });
        } catch (error) {
          console.log("予期せぬエラーが発生しました:", error);
        }
      };
      const fetchCause = async () => {
        try {
          await triggerGetCause({ assignment_word: keyword });
        } catch (error) {
          console.log("予期せぬエラーが発生しました:", error);
        }
      };
      fetchKeywords();
      fetchClustering();
      fetchCause();
      sessionStorage.setItem("hasVisited", "true"); // リロードしても実行されないようにセッションストレージにフラグを保存
    }
  }, []);

  useEffect(() => {
    if (getMinutesFetching === false) {
      // フェッチ後のトースト表示設定
      if (getMinutesError) {
        let errMsg = "";
        if ("status" in getMinutesError) {
          // FetchBaseQueryError
          const data = getMinutesError.data as ErrorResponse;
          errMsg = data?.detail_msg ?? "検索に失敗しました。";
        } else {
          // SerializedError
          errMsg = getMinutesError.message ?? "検索に失敗しました。";
        }
        setErrorOpen(true);
        setErrMessage(errMsg);
      } else if (deleteMinuteError) {
        let errMsg = "";
        if ("status" in deleteMinuteError) {
          // FetchBaseQueryError
          errMsg = "メモの削除に失敗しました。";
        } else {
          // SerializedError
          errMsg = "メモの削除に失敗しました。";
        }
        setErrorOpen(true);
        setErrMessage(errMsg);
      } else if (getMinutesData?.minutes_list?.length === 0) {
        const infoMsg = "検索結果が0件でした。";
        setInfoMessage(infoMsg);
        setInfoOpen(true);
      } else if (deleteMinuteSuccess) {
        const infoMsg =
          "メモを削除しました。\nポップアップを閉じると一覧が更新されます。";
        setInfoMessage(infoMsg);
        setInfoOpen(true);
        setDisabledDeleteButton(true);
      } else if (!deleteMinuteSuccess) {
        setDisabledDeleteButton(false);
      }
    }
  }, [
    getMinutesError,
    getMinutesData,
    getMinutesFetching,
    deleteMinuteData,
    deleteMinuteError,
    deleteMinuteSuccess,
    deleteMinuteReset,
  ]);

  const columns = [
    {
      name: "id",
      label: "ID",
      options: {
        filter: true,
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
          const rowIndex = Number(tableMeta.rowIndex) + 1;
          return <span>{rowIndex}</span>;
        },
      },
    },
    {
      name: "title",
      label: "タイトル",
      options: { filter: true },
    },
    {
      name: "meeting_timestamp",
      label: "商談日",
      options: {
        filter: true,
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
          return toISOStringWithTimezone(new Date(value * 1000)).slice(0, 10);
        },
      },
    },
    {
      name: "company_name",
      label: "企業名",
      options: { filter: true },
    },
    {
      name: "content",
      label: "内容",
      options: {
        filter: true,
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
          return toBreakedText(value);
        },
      },
    },
    {
      name: "issue_action",
      label: "課題アクション",
      options: {
        filter: true,
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
          if (value === null) {
            return "なし";
          } else {
            // 両方空の場合は"なし"と表示
            const nonEmptyIssues = value.filter(
              (issue: any) =>
                issue.issue.trim() !== "" ||
                issue.actions.some((action: any) => action.action.trim() !== "")
            );
            if (nonEmptyIssues.length === 0) {
              return "なし";
            }
            // 空でない課題をカウント
            const issueCount = nonEmptyIssues.filter(
              (issue: any) => issue.issue.trim() !== ""
            ).length;
            // 空でないアクションをカウント
            const actionCount = nonEmptyIssues.reduce(
              (acc: number, issue: any) => {
                return (
                  acc +
                  issue.actions.filter(
                    (action: any) => action.action.trim() !== ""
                  ).length
                );
              },
              0
            );

            return `課題${issueCount}個/アクション${actionCount}個`;
          }
        },
      },
    },
    {
      name: "created_timestamp",
      label: "メモ作成日時",
      options: {
        filter: true,
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
          return toISOStringWithTimezone(new Date(value * 1000));
        },
      },
    },
    {
      name: "updated_timestamp",
      label: "最終更新日時",
      options: {
        filter: true,
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
          return toISOStringWithTimezone(new Date(value * 1000));
        },
      },
    },
    {
      name: "",
      options: {
        filter: false,
        sort: false,
        empty: false,
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
          return (
            <Stack spacing={2}>
              <Link
                to={{
                  pathname: Path.create + `/${tableMeta.rowData[0]}`,
                }}
              >
                <CustomButton
                  variant="contained"
                  color="primary"
                  onClick={() => handleClose()}
                >
                  詳細
                </CustomButton>
              </Link>
              <CustomButton
                variant="contained"
                color="error"
                onClick={() => {
                  handleOpen(tableMeta.rowData[0]);
                }}
              >
                削除
              </CustomButton>
              <Modal
                open={open}
                onClose={() => {
                  handleClose();
                  handleSubmit();
                  deleteMinuteReset();
                }}
                sx={{
                  "& .MuiModal-backdrop": {
                    backgroundColor: "rgba(255, 255, 255, 0.05);",
                  },
                }}
              >
                <Box sx={DeleteBoxStyle}>
                  <Typography>
                    <span>
                      選択した商談メモを本当に削除しますか？
                      <br />
                      削除後は復元できません。
                    </span>
                  </Typography>
                  <DeleteModalDiv>
                    <Stack direction="row" spacing={5} justifyContent="center">
                      <DeleteCustomButton
                        variant="contained"
                        onClick={() => {
                          handleDelete(id);
                        }}
                        disabled={disabledDeleteButton}
                      >
                        削除
                      </DeleteCustomButton>
                      <DeleteCustomButton
                        variant="contained"
                        onClick={() => {
                          handleClose();
                          handleSubmit();
                          deleteMinuteReset();
                        }}
                      >
                        キャンセル
                      </DeleteCustomButton>
                    </Stack>
                  </DeleteModalDiv>
                </Box>
              </Modal>
            </Stack>
          );
        },
      },
    },
  ];

  function toISOStringWithTimezone(date: Date): string {
    const pad = function (str: string): string {
      return ("0" + str).slice(-2);
    };
    const year = date.getFullYear().toString();
    const month = pad((date.getMonth() + 1).toString());
    const day = pad(date.getDate().toString());
    const hour = pad(date.getHours().toString());
    const minute = pad(date.getMinutes().toString());
    return `${year}/${month}/${day} ${hour}:${minute}`;
  }

  function toBreakedText(text: string) {
    const breakedText = text.split("\\n").map((line, key) => (
      <span key={key}>
        {line}
        <br />
      </span>
    ));
    return breakedText;
  }

  const formValidation = (): boolean => {
    //キーワードのバリデーション
    if (search.length > 32) {
      // 33文字以上はNG.
      const errMsg = "検索キーワードの入力上限は32文字です。";
      setErrorOpen(true);
      setErrMessage(errMsg);
      return true;
    }
    return false;
  };

  const handleSubmit = () => {
    if (!formValidation()) {
      getMinutes(search);
    }
  };

  const handleDelete = (id: string) => {
    deleteMinute(id);
  };

  return (
    <Box sx={{ whiteSpace: "pre-line" }}>
      <Grid container>
        <Grid item xs={12}>
          <Title>商談メモ一覧</Title>
        </Grid>
      </Grid>
      <Divider variant="middle" />
      <Grid container>
        <Grid item xs={5}>
          <SearchDiv>
            <SearchTypography
              aria-owns={popoverOpen ? "mouse-over-popover" : undefined}
              aria-haspopup="true"
              onMouseEnter={handlePopoverOpen}
              onMouseLeave={handlePopoverClose}
            >
              検索キーワード
            </SearchTypography>
            <Popover
              id="mouse-over-popover"
              sx={{ pointerEvents: "none" }}
              open={popoverOpen}
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              onClose={handlePopoverClose}
              disableRestoreFocus
            >
              <Typography sx={{ p: 1 }}>
                議事録の内容を部分一致で検索します。
              </Typography>
            </Popover>
            <SearchTextInput
              required
              type="text"
              size="small"
              value={search}
              error={searchError}
              helperText={searchError ? "キーワードを入力してください。" : " "}
              onChange={(inputSearch) => {
                setSearchError(false);
                setSearch(inputSearch.target.value);
              }}
            />
          </SearchDiv>
        </Grid>
        <Grid item xs={1}>
          <ButtonDiv>
            <Button
              disabled={getMinutesFetching}
              variant="contained"
              onClick={handleSubmit}
            >
              検索
            </Button>
          </ButtonDiv>
        </Grid>
        <Grid item xs={1}>
          <ButtonDiv>
            <Link to={{ pathname: Path.create }}>
              <Button
                disabled={getMinutesFetching}
                variant="contained"
                sx={{ whiteSpace: "nowrap" }}
              >
                新規追加
              </Button>
            </Link>
          </ButtonDiv>
        </Grid>
      </Grid>

      <TextInit>
        {getMinutesData === undefined && <Box p={2}>{initMsg}</Box>}
      </TextInit>

      <TableDiv>
        {getMinutesFetching && <LinearProgress />}
        {getMinutesData && (
          <MUIDataTable
            title=""
            data={getMinutesData ? getMinutesData.minutes_list : []}
            columns={columns}
            options={options}
          />
        )}
      </TableDiv>

      <Snackbar
        open={errorOpen}
        autoHideDuration={5000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={errorHandleClose}
      >
        <Alert
          onClose={errorHandleClose}
          severity="error"
          sx={{ width: "100%" }}
        >
          {errMessage}
        </Alert>
      </Snackbar>

      <Snackbar
        open={infoOpen}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={infoHandleClose}
      >
        <Alert onClose={infoHandleClose} severity="info" sx={{ width: "100%" }}>
          {infoMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default ListPage;
